const VentanillaUnicaSection = () => {
    const items = [
      {
        title: '¿A qué alquileres aplica?',
        content:
          'A cualquier vivienda o habitación alquilada por días, semanas o meses a través de plataformas como Airbnb, Booking u otras.',
      },
      {
        title: '¿Qué es la Ventanilla Única Digital?',
        content:
          'Es un sistema del Gobierno que centraliza la información de viviendas en alquiler de corta duración para cumplir con el reglamento europeo.',
      },
      {
        title: 'Viviendas turísticas y la normativa local',
        content:
          'Las viviendas de uso turístico deben cumplir con los requisitos establecidos por las autoridades autonómicas y locales correspondientes.',
        featured: true,
      },
      {
        title: '¿Qué deben hacer los arrendadores?',
        content:
          'Deben solicitar el número de registro turístico en la plataforma habilitada por el Gobierno, y mantener sus datos actualizados.',
      },
      {
        title: 'Contexto normativo',
        content:
          'España lidera la aplicación del nuevo Reglamento Europeo sobre transparencia en el alquiler de corta duración, siendo el primer país en implementarlo.',
      },
      {
        title: '¿Qué hacen las plataformas de alquiler?',
        content:
          'Revisan y recopilan los números de registro de cada alojamiento y los envían a la Ventanilla Única, asegurando el cumplimiento normativo.',
      },
    ];
  
    return (
      <section style={{ padding: '60px 20px', backgroundColor: '#fff' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '1.8rem', color: '#1a237e', fontWeight: 'bold', marginBottom: '40px' }}>
            ¿Qué es y cómo funciona la Ventanilla Única?
          </h2>
  
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '20px',
              textAlign: 'left',
            }}
          >
            {items.map((item, idx) => (
              <div
                key={idx}
                style={{
                  padding: '24px',
                  borderRadius: '12px',
                  backgroundColor: item.featured ? '#1a237e' : '#fff',
                  border: item.featured ? 'none' : '2px solid #f4e8a1',
                  color: item.featured ? '#fff' : '#333',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                }}
              >
                <p style={{ fontWeight: 'bold', fontSize: '1rem', marginBottom: '10px' }}>
                  {item.title}
                </p>
                <p style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>{item.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };
  
  export default VentanillaUnicaSection;
  